module.exports = __webpack_public_path__ + "img/sintesis2.d089637b.svg";